const SolutionCoverageConstant = {
    key: "solution coverage",
    value: [
        {
            agentCode: "10-30",
            agentName: "10% to 30%"
        },
        {
            agentCode: "31-50%",
            agentName: "31% to 50%"
        },
        {
            agentCode: "51-70",
            agentName: "51% to 70%"
        },
        {
            agentCode: "71-90",
            agentName: "71% to 90%"
        },
        {
            agentCode: "91-100",
            agentName: "91% to 100%"
        },
        {
            agentCode: "All",
            agentName: "All"
        },
    ]


}
export default SolutionCoverageConstant